/*eslint eqeqeq: "off"*/
// React
import React from 'react';

// Components
import ModalComponent from 'shared/components/modal/ModalComponent';
import PrimaryButtonComponent from 'shared/components/primary-button/PrimaryButtonComponent';
import TextButtonComponent from 'shared/components/text-button/TextButtonComponent';

// Styles
import './TournamentPaymentBlockModalComponent.styles.css';

//i18
import { withTranslation } from 'react-i18next';

function TournamentPaymentBlockModalComponent ( props ) {
    return(
        <ModalComponent
            isOpen={props.isOpen} 
            title={'title'}
            className='tournament-payment-block-modal'
        >
            <div className='tournament-payment-block-modal__container'>
                <div><span className='hubicon-lock' /></div>
                <div className="baloa-subtitle-1">
                    {props.t('paymentLockedModal.title')}
                </div>
                <div className="baloa-normal">                    
                    {props.is_tournament_admin?
                        props.t('paymentLockedModal.adminMessage')
                    :
                        props.t('paymentLockedModal.message')
                    }
                </div>
                {props.is_tournament_admin?
                    <React.Fragment>
                        <PrimaryButtonComponent 
                            onClick={() => {props.handleOnButton()}}
                            className={''}
                        >
                            <span>{props.t('paymentLockedModal.makePaymentBtnLbl')}</span>
                        </PrimaryButtonComponent>
                        {/* <TextButtonComponent
                            onClick={() => {props.onClose()}}
                            className={''}
                        >
                            <span>{props.t('paymentLockedModal.doItLaterBtnLbl')}</span>
                        </TextButtonComponent> */}
                    </React.Fragment>
                    :
                    <PrimaryButtonComponent 
                        onClick={() => {props.onClose()}}
                        className={''}
                    >
                        <span>{props.t('paymentLockedModal.understand')}</span>
                    </PrimaryButtonComponent>
                }
                
            </div>
        </ModalComponent>
    )
}

export default withTranslation('payments')(TournamentPaymentBlockModalComponent);